import React from 'react';
import theme from '@paradigm/themes/base/desktop_s';
import {Select, ThemeProvider, Icon} from '2kit';
import MENU from '!svgson-loader!./img/ic_burger.svg';
import ls from 'local-storage';
import MUIDrawer from '@material-ui/core/Drawer';
import {Link} from 'react-router-dom';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Hidden from '@material-ui/core/Hidden';
import Drawer from '@/components/Drawer';
import themes from '@/themes';
import {mainUrl, urlsImg, extendedPages} from '@/pages/configPages';

import s from './MainWrapper.module.css';

const OPTIONS = Array.from(themes.keys());
const THEME = 'Theme';

const fontFamily = theme.fontFamily;
const customTheme = {
    ...theme,
    ...{
        sizeControlHeight: 48,
        fontControl: {
            fontSize: 17,
            lineHeight: '24px',
            paddingControlHorizontal: 20,
            sizeBorderRadius: 4,
            fontFamily,
        },
    },
};

class ResponsiveDrawer extends React.Component {
    state = {
        mobileOpen: false,
        currentTheme: ls.get(THEME) || 'Base',
    };

    handleDrawerToggle = () => {
        console.log('handleDrawerToggle');
        this.setState(state => ({ mobileOpen: !state.mobileOpen }));
    };

    handlerChangeTheme = (value) => {
        this.setState({currentTheme: value});
        ls.set(THEME, value);
    };

    isInternalPage = () => {
        const {pathname} = this.props.location;
        let result = false;
        extendedPages.forEach(({url, childrens}) => {
            result = result || (pathname === url);
            if (childrens) {
                childrens.forEach(({url}) => result = result || (pathname === url));
            }
        });
        return result;
    }

    themeComponent() {
        const {currentTheme} = this.state;
        return (
            <>
                <Link to={mainUrl} className={s.logo}>
                    <img
                        src={urlsImg.logoSmall}
                        alt="logo"
                        width="177"
                        height="48"
                    />
                </Link>

                <div className={s.select}>
                    <ThemeProvider theme={customTheme}>
                        <Select
                            name="Themes"
                            value={currentTheme}
                            options={OPTIONS}
                            menuMaxHeight={300}
                            onChange={this.handlerChangeTheme}
                        />
                    </ThemeProvider>
                </div>
            </>
        )
    }

    render() {
        const {children} = this.props;
        const {currentTheme} = this.state;
        const isInternalPage = this.isInternalPage();
        return (
            <div className={s.root}>
                <nav className={s.drawer}>
                {/* <nav className={s.drawer}> */}
                    {/* The implementation can be swap with js to avoid SEO duplication of links. */}
                    <Hidden mdUp implementation="css">
                        <SwipeableDrawer
                            container={this.props.container}
                            variant="temporary"
                            anchor={'left'}
                            open={this.state.mobileOpen}
                            onClose={this.handleDrawerToggle}
                            onOpen={this.handleDrawerToggle}
                            classes={{
                                paper: `${s.drawerPaper} ${s.drawerPaperSwipable}`,
                            }}
                            ModalProps={{
                                keepMounted: true, // Better open performance on mobile.
                            }}
                        >
                            {this.themeComponent()}
                            <div onClick={this.handleDrawerToggle}>
                              <Drawer />
                            </div>
                        </SwipeableDrawer>
                    </Hidden>

                    <Hidden smDown implementation="css">
                        <MUIDrawer
                            classes={{
                                paper: `${s.drawerPaper} ${isInternalPage ? s.drawerPaperInternalPage : s.drawerPaperMainPage}`,
                            }}
                            variant="permanent"
                            open
                        >
                            {this.themeComponent()}

                            <Drawer />
                        </MUIDrawer>
                    </Hidden>
                </nav>

                <ThemeProvider theme={{current: themes.get(currentTheme)}}>
                    <main className={s.content}>
                        <Hidden mdUp implementation="css">
                            <header className={`${s.header} ${isInternalPage ? s.drawerPaperInternalPage : s.drawerPaperMainPage}`}>
                                <div onClick={this.handleDrawerToggle}>
                                    <Icon icon={MENU} classes={{base: s.icon}}/>
                                </div>
                                <img
                                    className={s.logoHeader}
                                    src={urlsImg.logoSmall}
                                    alt="logo"
                                />
                            </header>
                        </Hidden>
                        {children}
                    </main>
                </ThemeProvider>
            </div>
        );
    }
}

export default ResponsiveDrawer;
